import React from "react";

// Ícone do canal: logo (Cardápio, iFood, marketplaces) ou ícone do lucide.
// `cinza` apaga a logo — usado nos cartões "em breve".
export default function IconeCanal({ canal, className = "w-5 h-5", cinza = false }) {
  if (canal.logo) {
    return (
      <img src={canal.logo} alt={canal.nome} className={`${className} object-contain ${cinza ? "grayscale opacity-70" : ""}`}
        onError={(e) => { e.currentTarget.style.visibility = "hidden"; }} />
    );
  }
  const { Icon } = canal;
  return <Icon className={className} />;
}
